export type RebuildRouteId =
  | 'home'
  | 'start-stream'
  | 'themes'
  | 'weekend-prep'
  | 'obs'
  | 'reports'
  | 'raid-finder'
  | 'viewers'
  | 'welcomes'
  | 'loyalty'
  | 'alerts'
  | 'sounds'
  | 'printer'
  | 'text-outputs'
  | 'wam'
  | 'chat-bot'
  | 'commands'
  | 'automations'
  | 'system-health'
  | 'logs'
  | 'integrations'
  | 'modules'
  | 'access';

export type RebuildNavItem = {
  id: RebuildRouteId;
  label: string;
  description: string;
  ownerOnly?: boolean;
};

export type RebuildNavGroup = {
  label: string;
  items: RebuildNavItem[];
};

export const REBUILD_NAVIGATION: RebuildNavGroup[] = [
  {
    label: 'Live',
    items: [
      { id: 'home', label: 'Control Room', description: 'What matters right now.' },
      { id: 'start-stream', label: 'Sessions', description: 'Prepare, check and begin a stream.' },
      { id: 'themes', label: 'Themes', description: 'Themes, welcomes and alerts.', ownerOnly: true },
      { id: 'weekend-prep', label: 'Weekend Prep', description: 'Prepare Friday and weekend stream content.' },
      { id: 'obs', label: 'OBS', description: 'Scenes, stream and recording controls.' },
      { id: 'reports', label: 'Reports', description: 'Recent stream sessions and outcomes.' },
      { id: 'raid-finder', label: 'Raid Finder', description: 'Find live same-category Twitch channels.', ownerOnly: true },
    ],
  },
  {
    label: 'People',
    items: [
      { id: 'viewers', label: 'Viewers & Loyalty', description: 'Viewer history, moderation, points and loyalty rules.' },
      { id: 'loyalty', label: 'Loyalty', description: 'Viewer points, rankings and earning rules.' },
      { id: 'welcomes', label: 'Welcomes', description: 'Welcome rules, sounds and personalised entries.' },
      { id: 'alerts', label: 'Alerts', description: 'Follows, subscriptions, raids and Bits.' },
    ],
  },
  {
    label: 'Media',
    items: [
      { id: 'sounds', label: 'Sounds', description: 'Private and viewer soundboards.' },
      { id: 'printer', label: 'Printer', description: 'Stream-event receipt output.' },
      { id: 'text-outputs', label: 'Text Outputs', description: 'Files used by OBS and other tools.' },
    ],
  },
  {
    label: 'Games',
    items: [
      { id: 'wam', label: 'WhatsAMusic', description: 'Categories, suggestions, voting and results.' },
    ],
  },
  {
    label: 'Automation',
    items: [
      { id: 'chat-bot', label: 'Chat Bot', description: 'Bot controls, commands, notices and automation.' },
      { id: 'commands', label: 'Commands', description: 'Create and manage chat commands.' },
      { id: 'automations', label: 'Automations', description: 'Keyword and event-driven actions.' },
    ],
  },
  {
    label: 'System',
    items: [
      { id: 'system-health', label: 'System Health', description: 'FFSControl, Agents and services.' },
      { id: 'logs', label: 'Logs', description: 'Operational logs and troubleshooting.' },
      { id: 'integrations', label: 'Integrations', description: 'External API connections.', ownerOnly: true },
      { id: 'modules', label: 'Modules', description: 'Optional module lifecycle and runtime state.', ownerOnly: true },
      { id: 'access', label: 'Access & Security', description: 'Sign-in, sessions and security.', ownerOnly: true },
    ],
  },
];

export const REBUILD_ROUTE_LABELS = Object.fromEntries(
  REBUILD_NAVIGATION.flatMap((group) => group.items.map((item) => [item.id, item.label])),
) as Record<RebuildRouteId, string>;
